// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FieldValueRequest } from './field-value-request';

/** See com.rev360.pms.api.controller.shared.field.FieldValueLargeStringRequest */
/* istanbul ignore next */
@GandalfModel
export class FieldValueLargeStringRequest extends FieldValueRequest {

	@GandalfProperty({ designType: Number })
	fieldId!: number | null;

	@GandalfValidator({ sizeString: { message: 'Value cannot be longer than 16000 characters', minLength: 0, maxLength: 16000 } })
	@GandalfProperty({ designType: String })
	value!: string | null;

}
